import { selectSpouseInformation } from "store/reducers/user/UserAccountSlice";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { trackDashboardCtaClicked } from "analytics";
import { PATHS } from "constants/pathConstants";
import InviteSpouseIcon from "assets/images/Icon-Invite_Spouse.svg";
import DashboardCtaCard from ".";
import Translate from "translate/Translate";

const InviteSpouseDashboardCtaCard = () => {
  const history = useHistory();
  const spouseAccessCode = useSelector(selectSpouseInformation)
    ?.spouseAccessCode;

  if (!spouseAccessCode) {
    return null;
  }

  return (
    <DashboardCtaCard
      icon={InviteSpouseIcon}
      header={<Translate text={"Invite Spouse"} />}
      subheader={
        <Translate
          text={"Good news! Your spouse is included in your membership."}
        />
      }
      link={{
        onClick: () => {
          trackDashboardCtaClicked({
            workflow: "spouse_invite",
            ctaLocation: "todo_card",
            ctaId: "invite_spouse"
          });
          history.push(PATHS.ACCOUNT_MANAGEMENT_PAYMENT_INFORMATION);
        },
        overrideClick: true,
        text: "Learn More",
        url: PATHS.ACCOUNT_MANAGEMENT_PAYMENT_INFORMATION
      }}
    />
  );
};

export default InviteSpouseDashboardCtaCard;
